module.exports = __webpack_public_path__ + "static/media/cogent1.7cb40aae.png";